import { jsx as _jsx } from "react/jsx-runtime";
import $ from "jquery";
import { createRoot } from "react-dom/client";
import { ShortcutIconTooltip } from "../components/media/shortcutIconTooltip.js";
function decorateAttachmentShortcutIcon($el, model) {
    const isShortcut = (model.attributes.rmlIsShortcut ?? 0) > 0;
    let icon = $el.children(".attachment-preview").children(".rml-shortcut-container");
    icon.remove();
    if (isShortcut) {
        $el.addClass("rml-shortcut rml-shortcut-grid");
        icon = $('<div class="rml-shortcut-container"></div>').appendTo($el.children(".attachment-preview"));
        createRoot(icon.get(0)).render(/*#__PURE__*/ _jsx(ShortcutIconTooltip, {}));
    } else {
        $el.removeClass("rml-shortcut rml-shortcut-grid");
    }
}
/**
 * When a grid item is removed, also remove duplicate shortcuts that point at it.
 */ function removeDuplicateShortcuts(model, collection) {
    const { id } = model.attributes;
    collection.models.forEach((single)=>{
        if (single.attributes.rmlIsShortcut === id) {
            collection.remove(single);
        }
    });
}
/**
 * List-mode shortcut icon for rows marked with the PHP row-action helper span.
 */ function applyShortcutListIcon(span) {
    const tr = $(span).parents("tr");
    const imgContainer = tr.children("td.title").find(".media-icon");
    if (!imgContainer.length || imgContainer.children(".rml-shortcut-container").length) {
        return;
    }
    const icon = $('<div class="rml-shortcut-container"></div>').appendTo(imgContainer);
    createRoot(icon.get(0)).render(/*#__PURE__*/ _jsx(ShortcutIconTooltip, {}));
}
export { applyShortcutListIcon, decorateAttachmentShortcutIcon, removeDuplicateShortcuts };
